export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <a href="/" className="font-heading text-2xl font-bold">
              VigorBuy<span className="text-accent-500">Sheet</span>
            </a>
            <p className="mt-4 text-foreground-300 text-sm leading-relaxed max-w-md">
              The most comprehensive VigorBuy Spreadsheet resource online. Discover trusted sellers, QC-verified products, and the latest spreadsheet links — updated daily.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><a href="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">Home</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">VigorBuy Sheet</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">Buy It Now</a></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Resources</h4>
            <ul className="space-y-2.5">
              <li><a href="/article/vigorbuy-spreadsheet-guide-2026" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">Beginner&apos;s Guide</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">Shop Now</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} VigorBuy Spreadsheet Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">Privacy Policy</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}